import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { Input } from '@alfa-bank/site-input';
import { getCaption } from '@alfa-bank/site-form-helpers/meta/get-caption';
import { isError } from '@alfa-bank/site-form-helpers/meta/is-error';
import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';

import type { TEmbossing, IDeps } from './models';
import { Embossing as Component } from './embossing';
import styles from './styles/styles.css';

export const FormEmbossing = createWidget<IDeps, TEmbossing>({
    Field,
    Input,
    getCaption,
    isError,
    validateNotEmpty,
    styles,
})(Component);
